import classNames from 'classnames';
import React__default, { useContext, useState } from 'react';
import Styles from './ServiceTypeSelection.module.scss.js';
import { ReactComponent as SvgLoadOwnerIcon } from '../../../icons/load_owner_icon.svg.js';
import { ReactComponent as SvgLorryOwnerIcon } from '../../../icons/lorry_owner_icon.svg.js';
import { ReactComponent as SvgTransporterIcon } from '../../../icons/transporter_icon.svg.js';
import { ReactComponent as SvgFindLoad } from '../../../icons/find-load.svg.js';
import { ReactComponent as SvgFindLorry } from '../../../icons/find-lorry.svg.js';
import { ReactComponent as SvgFindLoadLorry } from '../../../icons/find-load-lorry.svg.js';
import { AppContext } from '../../../app-context.js';
import { CompanyServiceType } from '../../../constants/serviceTypeId.js';

const ServiceTypeOptions = [
    {
        label: "Truck Owner/Driver",
        value: CompanyServiceType.FLEET_OWNER,
        description: "I have truck(s) and I am looking for loads",
        icon: React__default.createElement(SvgLorryOwnerIcon, null),
        lookingForLabel: "Find Loads",
        lookingForIcon: React__default.createElement(SvgFindLoad, null)
    },
    {
        label: "Shipper",
        value: CompanyServiceType.SHIPPER,
        description: "I have loads and I am searching for trucks",
        icon: React__default.createElement(SvgLoadOwnerIcon, null),
        lookingForLabel: "Find Lorries",
        lookingForIcon: React__default.createElement(SvgFindLorry, null)
    },
    {
        label: "Transporter",
        value: CompanyServiceType.TRANSPORT_CONTRACTOR,
        description: "I am searching for both loads and lorries",
        icon: React__default.createElement(SvgTransporterIcon, null),
        lookingForLabel: "Find Loads & Lorries",
        lookingForIcon: React__default.createElement(SvgFindLoadLorry, null)
    }
];
const ServiceTypeSelection = ({ handleChange, name, className, serviceTypeModal }) => {
    const { isMobile, setServiceType } = useContext(AppContext);
    const [selectedServiceTypes, setSelectedServiceTypes] = useState();
    const handleServiceTypeSelection = (value) => {
        setSelectedServiceTypes(value);
        handleChange(value);
        setServiceType === null || setServiceType === void 0 ? void 0 : setServiceType(value);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: classNames(Styles.serviceTypeSelectionWrapper, className) }, ServiceTypeOptions.map(({ label, value, description, icon }, index) => (React__default.createElement("div", { className: classNames(Styles.serviceTypeInputContainer, selectedServiceTypes === value && Styles.isActive, isMobile && serviceTypeModal && Styles.serviceTypeModal), key: index, onClick: () => handleServiceTypeSelection(value) },
            React__default.createElement("div", { className: classNames(Styles.serviceTypeInputWrapper) },
                isMobile ? (React__default.createElement("div", { className: classNames(Styles.iconWrapper) }, icon)) : (React__default.createElement("div", { className: classNames(Styles.radioBtn) },
                    React__default.createElement("span", { className: classNames(Styles.circle, selectedServiceTypes === value && Styles.isActive) }))),
                React__default.createElement("div", { className: classNames(Styles.serviceTypeSelectionContent) },
                    React__default.createElement("span", { className: classNames(Styles.label) }, label),
                    React__default.createElement("span", { className: classNames(Styles.description) }, description))),
            !isMobile && React__default.createElement("div", { className: classNames(Styles.iconWrapper) }, icon)))))));
};

export { ServiceTypeOptions, ServiceTypeSelection as default };
//# sourceMappingURL=ServiceTypeSelection.js.map
